import Toast from 'primevue/toast';

export default {
  name: 'ToastWrapper',
  components: {
    Toast
  }
};